import axios from 'axios'
import * as Sentry from '@sentry/browser'

axios.interceptors.response.use(
  (response) => {
    return response
  },
  (err) => {
    Sentry.captureException(err)
    return Promise.reject(err)
  },
)

export default axios 
